import React, { useContext } from 'react';
import logo from "../../images/freshcart-logo.png";
import './Navbar.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { authContext } from '../../Context/Authentication';

export default function Navbar({ toggleSidebar }) {
  let { Token, setToken } = useContext(authContext);
  let navigate = useNavigate();

  function LogOut() {
    localStorage.removeItem('__inventory_sys_auth_token_5f9dA72xQp__');
    setToken(null);
    navigate('/login');
  }

  return (
    <nav className="navbar navbar-light bg-white fixed-top custom-navbar mb-5">
      <div className="container-fluid d-flex align-items-center">
        <div className="d-flex align-items-center gap-3">
          {/* Sidebar Toggle Button */}
          {Token && (
            <button
              onClick={toggleSidebar}
              className="sidebar-toggle-btn"
              type="button"
            >
              <i className="bi bi-list"></i>
            </button>
          )}

          {/* Logo */}
          <NavLink className="navbar-brand" to="/">
            <img src={logo} alt="logo" className="navbar-logo" width={250} />
          </NavLink>
        </div>

        {/* Right side (profile/logout) */}
        <div className="d-flex align-items-center gap-3 user-controls">
          {Token ? (
            <>
              {/* Notifications */}
              <NavLink className="nav-icon-btn position-relative" to="/noticifcations">
                <i className="bi bi-bell-fill fs-5"></i>
                <span className="notification-badge"></span>
              </NavLink>

              {/* Admin Profile */}
              <NavLink className="profile-link d-flex align-items-center gap-2" to="/alladmin">
                <i className="bi bi-person-circle fs-5"></i>
                <span className="d-none d-md-inline fw-medium">المستخدم </span>
              </NavLink>

              {/* Logout Button */}
              <button className="btn logout-btn d-flex align-items-center gap-2" onClick={LogOut}>
                <i className="bi bi-box-arrow-right"></i>
                <span>تسجيل الخروج</span>
              </button>
            </>
          ) : (
          null
          )}
        </div>
      </div>
    </nav>
  );
}